var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23174_112995",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23174_112995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 15H7.49935V13.3333H9.16602V11.6667H7.49935V10H5.83268V11.6667H4.16602V13.3333H5.83268V15ZM10.8327 12.0833H15.8327V10.8333H10.8327V12.0833ZM10.8327 14.5833H14.166V13.3333H10.8327V14.5833ZM3.33268 18.3333C2.87435 18.3333 2.48199 18.1701 2.1556 17.8438C1.82921 17.5174 1.66602 17.125 1.66602 16.6667V7.50001C1.66602 7.04167 1.82921 6.64931 2.1556 6.32292C2.48199 5.99653 2.87435 5.83334 3.33268 5.83334H7.49935V3.33334C7.49935 2.87501 7.66254 2.48264 7.98893 2.15626C8.31532 1.82987 8.70768 1.66667 9.16602 1.66667H10.8327C11.291 1.66667 11.6834 1.82987 12.0098 2.15626C12.3362 2.48264 12.4993 2.87501 12.4993 3.33334V5.83334H16.666C17.1243 5.83334 17.5167 5.99653 17.8431 6.32292C18.1695 6.64931 18.3327 7.04167 18.3327 7.50001V16.6667C18.3327 17.125 18.1695 17.5174 17.8431 17.8438C17.5167 18.1701 17.1243 18.3333 16.666 18.3333H3.33268ZM3.33268 16.6667H16.666V7.50001H12.4993C12.4993 7.95834 12.3362 8.3507 12.0098 8.67709C11.6834 9.00348 11.291 9.16667 10.8327 9.16667H9.16602C8.70768 9.16667 8.31532 9.00348 7.98893 8.67709C7.66254 8.3507 7.49935 7.95834 7.49935 7.50001H3.33268V16.6667ZM9.16602 7.50001H10.8327V3.33334H9.16602V7.50001Z",
    fill: "#475467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalInformation);
export default __webpack_public_path__ + "static/media/medical-information.d3bc7f6ff039ba340d9110f04b330f8b.svg";
export { ForwardRef as ReactComponent };